"use client";

import { ActivityIcon, StethoscopeIcon, WindIcon } from "lucide-react";

import { selectableTrackOptions } from "@/lib/auth/cert-visibility";
import {
  PROFESSION_OPTIONS,
  professionForTrack,
  type Profession,
} from "@/lib/onboarding/constants";
import { professionOf } from "@/lib/onboarding/flow";

import type { StepProps } from "../types";
import { SingleChoiceStep, useChooseAndAdvance } from "../ui";

const PROFESSION_ICONS: Record<Profession, typeof ActivityIcon> = {
  ems: ActivityIcon,
  nursing: StethoscopeIcon,
  respiratory: WindIcon,
};

/** Switching profession needs no cleanup here: flow.ts applicableAnswers
 *  drops a track from the old profession. */
export function ProfessionStep(props: StepProps) {
  const { state, env } = props;
  const choose = useChooseAndAdvance(props);
  const tracks = selectableTrackOptions(env.isInternal);
  const options = PROFESSION_OPTIONS.flatMap((opt) => {
    const inProfession = tracks.filter((t) => professionForTrack(t.value) === opt.value);
    return inProfession.length === 0
      ? []
      : [
          {
            value: opt.value,
            label: opt.label,
            description: inProfession.map((t) => t.label).join(", "),
            icon: PROFESSION_ICONS[opt.value],
          },
        ];
  });
  return (
    <SingleChoiceStep
      kicker="Your field"
      title={
        state.answers.audience === "instructor"
          ? "What do you teach?"
          : "What are you training for?"
      }
      options={options}
      selected={professionOf(state)}
      onPick={(profession) => choose({}, profession)}
    />
  );
}
